import { render, staticRenderFns } from "./mark-14.vue?vue&type=template&id=63383f34&scoped=true"
import script from "./mark-14.vue?vue&type=script&lang=js"
export * from "./mark-14.vue?vue&type=script&lang=js"
import style0 from "./mark-14.vue?vue&type=style&index=0&id=63383f34&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63383f34",
  null
  
)

export default component.exports